export default __webpack_public_path__ + "static/media/explain_more.b2a174d0.svg";